const recaptchaModes = {
	MODE_SCORE_THEN_CHECKBOX: 1,
	MODE_CHECKBOX_ONLY: 2,
	MODE_SCORE_ONLY: 3
};

export default recaptchaModes;
